import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getDistributorPage = (_: IncomingContent): Layout => ({
	name: 'HomeStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'Distributor', id: 'distributor'}],
		second: [],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
